var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClusteringOperationOutlinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5C9.933 13.5 11.5 11.933 11.5 10C11.5 8.067 9.933 6.5 8 6.5C6.067 6.5 4.5 8.067 4.5 10C4.5 11.933 6.067 13.5 8 13.5Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13C9.65685 13 11 11.6569 11 10C11 8.34315 9.65685 7 8 7C6.34315 7 5 8.34315 5 10C5 11.6569 6.34315 13 8 13Z",
    stroke: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1221 8.20801L13.9501 6.6654L16.2464 5.7398",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07367 7.31337L5.43164 4.72656",
    stroke: "#272D55",
    strokeWidth: 1.00025,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83315 14.0009L5.5625 12.4297",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2822 12.4277L13.8652 17.3807",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10781 4.916C5.47472 4.916 6.58281 3.81552 6.58281 2.458C6.58281 1.10048 5.47472 0 4.10781 0C2.74091 0 1.63281 1.10048 1.63281 2.458C1.63281 3.81552 2.74091 4.916 4.10781 4.916Z",
    fill: "#AECDFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10781 4.416C5.19857 4.416 6.08281 3.53937 6.08281 2.458C6.08281 1.37663 5.19857 0.5 4.10781 0.5C3.01705 0.5 2.13281 1.37663 2.13281 2.458C2.13281 3.53937 3.01705 4.416 4.10781 4.416Z",
    stroke: "#AECDFC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6501 7.11429C16.5152 7.4464 17.4841 7.01886 17.814 6.15935C18.144 5.29984 17.71 4.33384 16.8449 4.00173C15.9797 3.66962 15.0109 4.09716 14.6809 4.95667C14.351 5.81618 14.7849 6.78218 15.6501 7.11429Z",
    fill: "#AECDFC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8297 6.64801C16.4371 6.88116 17.1167 6.58239 17.3477 5.98068C17.5787 5.37897 17.2735 4.70218 16.6662 4.46903C16.0588 4.23588 15.3792 4.53466 15.1482 5.13636C14.9172 5.73807 15.2224 6.41486 15.8297 6.64801Z",
    stroke: "#AECDFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.248 19.3665C15.3515 19.3665 16.246 18.4778 16.246 17.3815C16.246 16.2852 15.3515 15.3965 14.248 15.3965C13.1445 15.3965 12.25 16.2852 12.25 17.3815C12.25 18.4778 13.1445 19.3665 14.248 19.3665Z",
    fill: "#AECDFC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.248 18.8665C15.0753 18.8665 15.746 18.2016 15.746 17.3815C15.746 16.5613 15.0753 15.8965 14.248 15.8965C13.4207 15.8965 12.75 16.5613 12.75 17.3815C12.75 18.2016 13.4207 18.8665 14.248 18.8665Z",
    stroke: "#AECDFC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42491 17.8256C3.71616 17.8256 4.76291 16.786 4.76291 15.5036C4.76291 14.2212 3.71616 13.1816 2.42491 13.1816C1.13367 13.1816 0.0869141 14.2212 0.0869141 15.5036C0.0869141 16.786 1.13367 17.8256 2.42491 17.8256Z",
    fill: "#AECDFC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42491 17.3256C3.44001 17.3256 4.26291 16.5099 4.26291 15.5036C4.26291 14.4974 3.44001 13.6816 2.42491 13.6816C1.40981 13.6816 0.586914 14.4974 0.586914 15.5036C0.586914 16.5099 1.40981 17.3256 2.42491 17.3256Z",
    stroke: "#AECDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClusteringOperationOutlinedIcon);
export default __webpack_public_path__ + "static/media/ClusteringOperationOutlinedIcon.329a7af8aacf594e630314a525fd4369.svg";
export { ForwardRef as ReactComponent };